import { ContactPermission } from '../../../models/inbox';
import { CommunicationService } from '../../services/communication/communication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSettings } from '../../utils/app-settings';
import { ContactPermissionTabs } from '../../../models/campaign';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { ContactPermissionStatus, RequestInfluencerType } from '../../../models/influencer';
import { UserService } from '../../services/user.service';
import { ModalService } from '../../services/modal/modal.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import * as Sentry from '@sentry/browser';
import { ActionDetails, ActionSource, EventTrackerService, Page, TargetType, UserActionType } from '../../services/event-tracker/event-tracker.service';
import { InfluencerRequestError } from '../influencer-details/fail-retrieve-campaign-modal/fail-retrieve-campaign-modal.component';
import { CommonConstant } from '../../app.constants';
import { AuthService } from '../../core/auth.service';
var ContactPermissionComponent = /** @class */ (function () {
    function ContactPermissionComponent(contactService, userService, modalService, router, activatedRoute, influencerService, eventTracker, auth) {
        this.contactService = contactService;
        this.userService = userService;
        this.modalService = modalService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.influencerService = influencerService;
        this.eventTracker = eventTracker;
        this.auth = auth;
        this.showActivityLog = true;
    }
    ContactPermissionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.hideSideBar();
        this.activatedRoute.queryParams.subscribe(function (qp) {
            if (qp.permissionToken) {
                _this.permissionToken = qp.permissionToken;
                _this.loadContactPermission(qp.permissionToken);
            }
            if (qp.accessToken) {
                _this.accessToken = qp.accessToken;
            }
        });
        this.selectedTab = ContactPermissionTabs.CONTACT_PERMISSION;
    };
    ContactPermissionComponent.prototype.ngOnDestroy = function () {
        this.showSideBar();
    };
    ContactPermissionComponent.prototype.loadContactPermission = function (permissionToken) {
        var _this = this;
        return this.contactService.getPermissionByToken(permissionToken).subscribe(function (res) {
            _this.contactPermission = res;
            var actionDetail = _this.getMPActionDetail();
            _this.sendMixpanelEvent(actionDetail);
            if (_this.contactPermission.status === ContactPermissionStatus.REJECTED) {
                _this.isDeletedOrError = true;
                _this.showErrorPopup(InfluencerRequestError.CONTACT_PERMISSION_DELETE);
            }
            else {
                // check whether the influncer has been confirmed their account
                _this.checkInfluencerConfirmation(_this.userService.getInfluencerInfo());
            }
        }, function (error) {
            // handle in case the WS PR didn't merge yet
            if (error.status === 404) {
                _this.contactPermission = new ContactPermission();
            }
            else {
                _this.isDeletedOrError = true;
                _this.showErrorPopup(InfluencerRequestError.RETREIVE_CONTACT_PERMISSION_REQUEST_FAIL);
            }
        });
    };
    ContactPermissionComponent.prototype.isActivatedAdvertiserChat = function () {
        return !AppSettings.isDisableChat();
    };
    ContactPermissionComponent.prototype.checkInfluencerConfirmation = function (influencer) {
        if (influencer && !influencer.acceptedTermService) {
            this.auth.needAcceptedTermAndCondition();
        }
    };
    ContactPermissionComponent.prototype.showErrorPopup = function (errorType) {
        this.errorType = errorType;
        this.modalService.openInCenter(this.warningFailToRetrieveContactPermission, null, 'fail-retrieve-camp', true);
    };
    ContactPermissionComponent.prototype.onSelectContactPermissionTab = function () {
        this.selectedTab = ContactPermissionTabs.CONTACT_PERMISSION;
    };
    ContactPermissionComponent.prototype.onSelectContactTab = function () {
        this.selectedTab = ContactPermissionTabs.CONTACT;
        this.loadInfluencerConversation(this.contactPermission.advertiserId, this.contactPermission.influencerId);
    };
    ContactPermissionComponent.prototype.loadInfluencerConversation = function (campaignCompany, influencerId) {
        var _this = this;
        this.contactService.fetchInfluencerConversation(campaignCompany, influencerId).subscribe(function (res) {
            _this.conversation = res;
        });
    };
    ContactPermissionComponent.prototype.isSelectedPermissionTab = function () {
        return this.selectedTab && this.selectedTab === ContactPermissionTabs.CONTACT_PERMISSION;
    };
    ContactPermissionComponent.prototype.isSelectedContactTab = function () {
        return this.selectedTab && this.selectedTab === ContactPermissionTabs.CONTACT;
    };
    ContactPermissionComponent.prototype.onDeclineContactPermissionRequest = function (evt) {
        var _this = this;
        this.goToAllSetOrRejectPage(false, null, true);
        this.influencerService.rejectContactPermission(evt).subscribe(function (res) {
            _this.sendMixpanelEvent(ActionDetails.INFLUENCER_REJECTED_REQUEST);
        }, function (error) {
            _this.goToAllSetOrRejectPage(false, null, false);
        });
    };
    ContactPermissionComponent.prototype.onAcceptContactPermissionRequest = function (evt) {
        var _this = this;
        this.goToAllSetOrRejectPage(true, true);
        this.influencerService.acceptContactPermission(evt).subscribe(function (res) {
            _this.sendMixpanelEvent(ActionDetails.INFLUENCER_ACCEPTED_REQUEST);
        }, function (error) {
            Sentry.captureException(error);
            return _this.goToAllSetOrRejectPage(true, false);
        });
    };
    ContactPermissionComponent.prototype.requestNewPermission = function () {
        var _this = this;
        var currentInfluencer = this.userService.getInfluencerInfo();
        if (currentInfluencer) {
            this.influencerService.requestNewCampaignInvitation(currentInfluencer.id, this.contactPermission.id, RequestInfluencerType.CONTACT_PERMISSION)
                .subscribe(function (res) {
                _this.modalService.close();
                _this.router.navigate(['dashboard', 'inbox']);
            }, function (err) {
                _this.modalService.close();
                _this.router.navigate(['dashboard', 'inbox']);
            });
        }
    };
    ContactPermissionComponent.prototype.hideSideBar = function () {
        document.body.classList.add('no-sidebar');
    };
    ContactPermissionComponent.prototype.showSideBar = function () {
        document.body.classList.remove('no-sidebar');
    };
    ContactPermissionComponent.prototype.goToAllSetOrRejectPage = function (isAcceptOrRejectContactPermission, acceptionResult, declineResult) {
        var queryParams;
        if (isAcceptOrRejectContactPermission) {
            queryParams = {
                accessToken: this.accessToken,
                permissionToken: this.permissionToken,
                requestType: 'contact_permission',
                acceptionResult: acceptionResult,
                influencerName: this.contactPermission.influencerName,
                company: this.contactPermission.agencyName,
                advertiserName: this.contactPermission.advertiserName,
                permissionId: this.contactPermission.id,
                advertiserId: this.contactPermission.advertiserId
            };
        }
        else {
            queryParams = {
                accessToken: this.accessToken,
                permissionToken: this.permissionToken,
                requestType: 'contact_permission',
                declineResult: declineResult,
                influencerName: this.contactPermission.influencerName,
                company: this.contactPermission.agencyName,
                advertiserName: this.contactPermission.advertiserName,
                permissionId: this.contactPermission.id,
                advertiserId: this.contactPermission.advertiserId
            };
        }
        return this.router.navigate(['user', 'all-set'], {
            queryParams: queryParams
        });
    };
    ContactPermissionComponent.prototype.sendMixpanelEvent = function (actionDetails, isAcceptOrRejectRequest) {
        if (!isAcceptOrRejectRequest) {
            this.eventTracker.trackUserAction(UserActionType.VIEW, Page.CONTACT_PERMISSION, {
                type: TargetType.ACCOUNT,
                id: this.contactPermission.advertiserId,
                name: this.contactPermission.agencyName
            }, {
                actionDetails: actionDetails,
                source: this.isLandingPageMode ? ActionSource.CAMPAIGN_LANDING_PAGE : ActionSource.INFLUENCER_APP,
                permissionId: this.contactPermission.id
            }, undefined, null);
        }
        else {
            this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CONTACT_PERMISSION, {
                type: TargetType.ACCOUNT,
                id: this.contactPermission.advertiserId,
                name: this.contactPermission.agencyName
            }, {
                actionDetails: actionDetails,
                source: this.isLandingPageMode ? ActionSource.CAMPAIGN_LANDING_PAGE : ActionSource.INFLUENCER_APP,
                advertiserId: this.contactPermission.advertiserId,
                action: UserActionType.UPDATE
            }, undefined, null);
        }
    };
    Object.defineProperty(ContactPermissionComponent.prototype, "isLandingPageMode", {
        get: function () {
            return this.accessToken;
        },
        enumerable: true,
        configurable: true
    });
    ContactPermissionComponent.prototype.isShowRetryButton = function (errorType) {
        return errorType === InfluencerRequestError.RETREIVE_CONTACT_PERMISSION_REQUEST_FAIL;
    };
    ContactPermissionComponent.prototype.tryAgainHandler = function (errorType) {
        if (!errorType) {
            return null;
        }
        if (errorType === InfluencerRequestError.CAMPAIGN_INVITATION_DELETE) {
            return this.requestNewPermission();
        }
        else {
            return this.reloadPlatform();
        }
    };
    ContactPermissionComponent.prototype.reloadPlatform = function () {
        this.modalService.close();
        return document.location.reload();
    };
    ContactPermissionComponent.prototype.getMPActionDetail = function () {
        var actionDetail;
        if (this.contactPermission.status.toLowerCase() === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name.toLowerCase()) {
            actionDetail = ActionDetails.INFLUENCER_INVITE_REQUEST;
        }
        else if (this.contactPermission.status.toLowerCase() === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name.toLowerCase()) {
            actionDetail = ActionDetails.INFLUENCER_ACCEPTED_REQUEST;
        }
        else if (this.contactPermission.status.toLowerCase() === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name.toLowerCase()) {
            actionDetail = ActionDetails.INFLUENCER_DECLINED_REQUEST;
        }
        return actionDetail;
    };
    return ContactPermissionComponent;
}());
export { ContactPermissionComponent };



// WEBPACK FOOTER //
// ./src/app/influencer-platform/contact-permission/contact-permission.component.ts.pre-build-optimizer.js